import React, { useState } from 'react'
import cn from 'classnames'
import * as st from '~/assets/styl/Hamburger.module.styl'
import { Link } from '~/components'
import { useLanguage } from '~/hooks'
import { hamburguer, menuBar } from '~/data'

interface Props {
  open: boolean
  onClose: () => void
}

export default function Hamburger({ open, onClose }: Props) {
  const [hover, setHover] = useState(-1)
  const { t } = useLanguage()
  return (
    <div
      className={cn(st.core, { [st.open]: open })}
      itemScope
      itemType="http://schema.org/SiteNavigationElement"
    >
      <ul>
        {hamburguer.map(({ to }, index) => (
          <li key={index} className={cn({ [st.hover]: hover === index })}>
            <Link
              href={`/${to}`}
              onMouseEnter={() => setHover(index)}
              onMouseLeave={() => setHover(-1)}
              onClick={onClose}
            >
              <span>
                {t('Hamburguer.items', { returnObjects: true })[index].name}
              </span>
            </Link>
          </li>
        ))}
        <div className={st.switchLanguage}>
          <a
            href="/dvert/"
            className={
              process.env.GATSBY_LANGUAGE === 'pt' ? st.active : undefined
            }
          >
            PT
          </a>
          <a
            href="/en/dvert/"
            className={
              process.env.GATSBY_LANGUAGE === 'en' ? st.active : undefined
            }
          >
            EN
          </a>
          <a
            href="/es/dvert/"
            className={
              process.env.GATSBY_LANGUAGE === 'es' ? st.active : undefined
            }
          >
            ES
          </a>
        </div>
      </ul>
      <button onClick={onClose}></button>
    </div>
  )
}
